import { Button } from "@mui/material";

export default function CalendarButton(props) {
  const { day, onChangeDay, selectedDateInfo, globalLoading } = props;

  const background =
    !day.disabled && (selectedDateInfo?.date.day === day.dayNumber ? "rgb(255, 108, 14)" : "rgb(255, 108, 14, 0.2)");

  return (
    <Button
      size={"small"}
      sx={{
        padding: 0,
        borderRadius: 8,
        minWidth: 40,
        minHeight: 40,
        background,
        color: selectedDateInfo?.date.day === day.dayNumber ? "white" : "rgb(255, 108, 14)",
        "&:focus": { background },
      }}
      onClick={onChangeDay}
      value={day.dayIso}
      disabled={day.disabled || globalLoading}
    >
      {day.dayNumber}
    </Button>
  );
}
